import { indexBy, pickBy, map, propOr, sortBy,keys, values, has, prop, is } from "ramda";
import { safeMerge } from "../../../components-common/_utils";
import { ActionButtonProps, ButtonTT } from "../../../components-common/buttons";
import { normalizeIds } from "../../../components-common/tables/columns/_builder";
import { IRootieComponent } from "../../../components-system";
import { ActionButtonConfig } from "./types";
import { action_buttons_defaults } from "./defaults.action-buttons";
import { ActionButton } from "../../../components-common/buttons/ActionButton";

export const processButton = <T, >(actionOrButtons:(string | Partial<ActionButtonConfig>)[] = []): IRootieComponent<ActionButtonProps & {id:string}>[] => {
   const buttonsProps = indexBy((x:any) => x["id"])(normalizeIds(actionOrButtons ? actionOrButtons : [],["key","kind","action"]));
   const actionToUse = values(safeMerge(pickBy((v:any,k:string) => has(k,buttonsProps),action_buttons_defaults),buttonsProps));
   const colsFinal:IRootieComponent<ActionButtonProps & {id:string}>[] = map(
     (x:ActionButtonProps & {id:string}) => ({
       Component: propOr(ActionButton, "Component")(x) as any,
       cat: "button",
       type: x.id,
        id: x.id,
       props: {
        ...x,
        id: x.id,
        kind: x.kind??x.id as any,
        action: x.action??x.id as any,
       }
     }),
     sortBy(propOr(1000,"order") as any, actionToUse as any));
   return colsFinal;
 }

 export const findPropInTree = (propName: string, obj: any): any => {
  if (has(propName, obj)) {
    return prop(propName, obj);
  }

  const valuesOf = values(obj);
  for (const value of valuesOf) {
    if (is(Object, value)) {
      const result = findPropInTree(propName, value);
      if (result !== undefined) {
        return result;
      }
    }
  }

  return undefined;
};
